let baseurl = 'https://a.distribuidoraemanuel.com.gt'
// let baseurl = 'http://localhost:8000'
let clientesurl = baseurl + '/apiventas/clientes/'
let comprasurl = baseurl + '/apicompras/comprastemporales/'
let detallecomprastemporalesurl = baseurl + '/apicompras/detallecomprastemporales/'
let facturaurl = baseurl + '/apiventas/factura/'
let cuadrarcajareparto = baseurl + '/apiventas/cuadrarreporte/'
let cotizacionurl = baseurl + '/apiventas/cotizacion/'
let cuadrarrepartourl = baseurl + '/apiventas/cuadrarreparto/'
let ubicacioncuadreurl = baseurl + '/apiventas/ubicacioncuadre/'
let reporte = baseurl + '/apireportes/'
let devolucionesurl = baseurl + '/apiventas/reportedevolucion/'
let kilometrajeurl = baseurl + '/apivehiculos/kilometraje/'
let revisionurl = baseurl + '/apivehiculos/revision/'
let kilometrajevendedorurl = baseurl + '/apivehiculos/kilometrajevendedor/'
let productourl = baseurl + '/apicatalogos/producto/'
let urlpresentaciones = baseurl + '/apicatalogos/presentacion/?limit=300'
let lineafacturaurl = baseurl + '/apiventas/lineafactura/'
let lineacotizacion = baseurl + '/apiventas/lineacotizacion/'
let rutas = baseurl + '/apicatalogos/rutas/'
let bancos = baseurl + '/apicatalogos/bancos/'
let usuarios = baseurl + '/apicatalogos/usuarios/'
let proveedoresurl = baseurl + '/apicompras/proveedor/'
let ubicacionrutas = baseurl + '/apicatalogos/ubicacionruta/'
let vehiculos = baseurl + '/apivehiculos/vehiculos/'
let extracciones = baseurl + '/apicaja/extraercaja/'
let caja = baseurl + '/apicaja/caja/'
let tipoextracciones = baseurl + '/apicaja/tipoextraccion/'
let lineanotacreditourl = baseurl + '/apiventas/lineanotacredito/'
let notacreditourl = baseurl + '/apiventas/notacredito/'

export { baseurl, clientesurl, comprasurl, detallecomprastemporalesurl,
facturaurl, cotizacionurl, devolucionesurl, kilometrajeurl,
  kilometrajevendedorurl, productourl, urlpresentaciones,
  lineafacturaurl, lineacotizacion, rutas, usuarios, proveedoresurl,
  ubicacionrutas, vehiculos, extracciones, caja,
  tipoextracciones, lineanotacreditourl, cuadrarrepartourl, ubicacioncuadreurl, notacreditourl,
  cuadrarcajareparto, reporte, bancos, revisionurl
}



// WEBPACK FOOTER //
// ./src/plugins/urlsbackend.js